import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-show-black-friday-modal',
  templateUrl: './show-black-friday-modal.component.html',
  styleUrls: ['./show-black-friday-modal.component.scss']
})
export class ShowBlackFridayModalComponent implements OnInit, OnDestroy {

  public imageUrl: string;

  constructor(
    public dialogRef: MatDialogRef<ShowBlackFridayModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.imageUrl = data.imageUrl;
  }

  ngOnInit() {
    // Prevent body scrolling when modal is open
    document.body.classList.add('no-scroll');
  }

  ngOnDestroy() {
    // Re-enable body scrolling when modal is closed
    document.body.classList.remove('no-scroll');
  }

  closeModal(): void {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/modals/show-black-friday-modal/show-black-friday-modal.component.ts